<template>
  <v-form v-model="valid" @submit.prevent="submit" ref="form" lazy-validation>
    <v-card>
      <v-card-title class="display-1">
        {{ title }}
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="value.date"
          :autofocus="$vuetify.breakpoint.smAndUp"
          :rules="[$rules.required, $rules.date]"
          label="Datum"
          type="date"
          box
        ></v-text-field>
        <v-autocomplete
          :items="stateOfProcedures"
          :rules="[$rules.required]"
          v-model="value.state_of_procedure"
          label="Verfahrensstand"
          box
          hide-no-data
        ></v-autocomplete>
        <v-textarea
          v-model="value.comment"
          label="Bemerkung"
          rows="3"
          box
        ></v-textarea>
        <FilesTable
          v-model="value.files"
          editable
        />
      </v-card-text>
      <v-card-actions>
        <v-btn
          :disabled="!valid"
          type="submit"
          color="primary"
          depressed
        >
          {{ submitText }}
        </v-btn>
        <v-btn
          @click="$emit('cancel')"
          depressed
        >Abbrechen</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import JournalEntry from '@/models/journal-entry';

export default {
  name: 'BusinessForm',
  props: {
    value: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: () => '',
    },
    submitText: {
      type: String,
      default: () => 'speichern',
    },
  },
  data() {
    return {
      stateOfProcedures: JournalEntry.stateOfProcedures,
      valid: true,
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.$emit('submit');
      }
    },
  },
};
</script>
